import { render } from "./disable2FAModal.vue?vue&type=template&id=19548b05&scoped=true"
import script from "./disable2FAModal.vue?vue&type=script&lang=js"
export * from "./disable2FAModal.vue?vue&type=script&lang=js"

import "./disable2FAModal.vue?vue&type=style&index=0&id=19548b05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19548b05"]])

export default __exports__